define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var tmpl = require('tmpl');
    var _ = require('underscore');
    var Model = require('backbone').Model;
    var SUPPORTED_KEY_CODES = {
        ENTER: 13,
        UP: 38,
        DOWN: 40,
        TAB: 9
    };
    var isNumeric = function(n) {
        return _.isNumber(n) && _.isFinite(n) && !_.isNaN(n);
    };

    require('common/jbone.widget');

    module.exports = $.widget('autocomplete', {

        options: {
            template: 'autocomplete.widget',
            minLength: 2,
            visibleRows: 5,
            delay: 300,
            collapseOnSelect: true,
            collapseOnScroll: true
        },

        init: function(options) {
            this.options = _.extend({}, this.options, options);
            this.id = _.uniqueId('.autocomplete');
            this.model = new Model({
                isHidden: true,
                isFocused: false,
                isSubscribedToWindowEvents: false,
                searchResult: []
            });

            this.onDocumentScroll = this.onDocumentScroll.bind(this);

            this.createContainer();
            this.subscribe();
        },

        createContainer: function() {
            this.$container = $('<ul>')
                .addClass(this.id.slice(1))
                .addClass('autocomplete-list')
                .addClass(this.options.className);

            var appendTo = this.el.closest('.field__control');

            $(appendTo).append(this.$container);
        },

        subscribe: function() {
            this.on(this.$el, {
                focusin: this.onTextFocus.bind(this),
                focusout: this.onTextFocusout.bind(this),
                input: _.debounce(this.onTextTyping.bind(this), this.options.delay)
            });

            this.on(this.$container, {
                tap: this.onItemClick.bind(this),
                mouseout: this.onItemMouseOut.bind(this),
                mouseover: this.onItemMouseOver.bind(this)
            });

            this.model.on('change:isHidden', this.onChangeIsHidden.bind(this));
            this.model.on('change:isFocused', this.reSubscribe.bind(this));
            this.model.on('change:activeItem', this.onChangeActiveItem.bind(this));
            this.model.on('change:searchResult', this.onChangeSearchResult.bind(this));

            document.addEventListener('scroll', this.onDocumentScroll, true);
        },

        // region DOM Events

        onTextFocus: function() {
            this.model.set({ isFocused: true });
        },

        onTextFocusout: function() {
            this.model.set({ isFocused: false });
        },

        onWindowTap: function(event) {
            if (this.el === event.target) {
                return;
            }

            if (!this.options.collapseOnSelect && $(event.target).hasClass('fn-autocomplete-item')) {
                return;
            }

            this.focusOut();
        },

        onWindowKeyDown: function(event) {
            var searchResultShown = !this.model.get('isHidden');
            var searchResult = this.model.get('searchResult');
            var activeItem = this.model.get('activeItem');
            var onSelect = this.options.onSelect;
            var keyCode = event.keyCode;

            var setActiveItem = function(value) {
                this.model.set({ activeItem: value });
            }.bind(this);

            var showSearchResult = function() {
                this.model.set({ isHidden: false });
            }.bind(this);

            var noResult = !searchResult || searchResult.length < 1;
            var hasError = searchResult && searchResult.errorCode;

            // should be first for breaking search by press on `Tab`
            if (SUPPORTED_KEY_CODES.TAB === keyCode) {
                this.focusOut();
                return;
            }

            if (_.values(SUPPORTED_KEY_CODES).includes(keyCode)) {
                event.preventDefault();
            }

            if (noResult || hasError) {
                return;
            }

            switch (keyCode) {
                case SUPPORTED_KEY_CODES.ENTER: {
                    if (activeItem != null && searchResultShown) {
                        onSelect && onSelect(activeItem);
                        this.focusOut();
                    }
                    break;
                }

                case SUPPORTED_KEY_CODES.UP: {
                    searchResultShown && setActiveItem(
                        activeItem == null || activeItem === 0
                            ? searchResult.length - 1
                            : activeItem - 1
                    );
                    break;
                }

                case SUPPORTED_KEY_CODES.DOWN: {
                    searchResultShown
                        ? setActiveItem(
                        activeItem == null || activeItem === searchResult.length - 1
                            ? 0
                            : activeItem + 1
                        )
                        : showSearchResult();
                    break;
                }

                default:
                    setActiveItem(null);
            }
        },

        onTextTyping: function(event) {
            this.search(event.target.value);
        },

        onItemClick: function(event) {
            var index = this.findActiveItemIndex(event.target);
            var onSelect = this.options.onSelect;

            index && onSelect && onSelect(index);
        },

        onItemMouseOver: function(event) {
            var index = this.findActiveItemIndex(event.target);

            index && this.model.set({ activeItem: Number(index) });
        },

        onItemMouseOut: function() {
            this.model.set({ activeItem: null });
        },

        onDocumentScroll: function(event) {
            if (this.options.collapseOnScroll && event.target !== this.$container[0]) {
                this.model.set({ isHidden: true });
            }
        },

        // endregion

        // region Model Events

        onChangeSearchResult: function() {
            this.renderAutocomplete(this.model.get('searchResult'));
        },

        onChangeIsHidden: function() {
            var isHidden = this.model.get('isHidden');

            this.$container.toggleClass('hidden', isHidden);
            this.reCalcContainerStyles();
            this.reSubscribe();

            if (isHidden) {
                this.options.onItemsHide?.();
            } else {
                this.options.onItemsShow?.();
            }
        },

        onChangeActiveItem: function() {
            var index = this.model.get('activeItem');
            var $items = this.$container.find('.fn-autocomplete-item');
            var activeItem = $items[index];

            $items.removeClass('hover');
            $(activeItem).addClass('hover');
            activeItem && this.scrollToActiveItem(activeItem);
        },

        // endregion

        reSubscribe: function() {
            var isHidden = this.model.get('isHidden');
            var isFocused = this.model.get('isFocused');

            if (isFocused || !isHidden) {
                this.subscribeToWindowEvents();
            } else {
                this.unsubscribeFromWindowEvents();
            }
        },

        subscribeToWindowEvents: function() {
            if (this.model.get('isSubscribedToWindowEvents')) {
                return;
            }

            $(window).on('tap' + this.id, this.onWindowTap.bind(this));
            $(window).on('keydown' + this.id, this.onWindowKeyDown.bind(this));
            $(window).on('resize' + this.id, _.debounce(this.reCalcContainerStyles.bind(this), 50));

            this.model.set('isSubscribedToWindowEvents', true);
        },

        unsubscribeFromWindowEvents: function() {
            $(window).off(this.id);

            this.model.set('isSubscribedToWindowEvents', false);
        },

        search: function(input) {
            var setResult = this.setResult.bind(this);
            var searchFn = this.options.search;
            var result = [];

            if (searchFn && input && input.length >= this.options.minLength) {
                result = searchFn(input);
            }

            // is promise
            if (window.Promise.resolve(result) === result) {
                result.then(setResult, setResult);
            } else {
                setResult(result);
            }
        },

        setResult: function(result) {
            if (result) {
                this.model.set({
                    isHidden: Array.isArray(result) && !result.length,
                    searchResult: result,
                    activeItem: null
                });
            }
        },

        scrollToActiveItem: function(activeItem) {
            var container = this.$container[0];

            if (container.scrollHeight > container.clientHeight) {
                var scrollBottom = container.clientHeight + container.scrollTop;
                var activeItemBottom = activeItem.offsetTop + activeItem.offsetHeight;

                if (activeItemBottom > scrollBottom) {
                    container.scrollTop = activeItemBottom - container.clientHeight;
                } else if (activeItem.offsetTop < container.scrollTop) {
                    container.scrollTop = activeItem.offsetTop;
                }
            }
        },

        focusOut: function() {
            this.model.set({
                isHidden: true,
                activeItem: null
            });
        },

        destroy: function() {
            $.Widget.prototype.destroy.call(this);
            this.$container.remove();
            this.model.off('change');
            $(window).off(this.id);
            document.removeEventListener('scroll', this.onDocumentScroll, true);
        },

        reCalcContainerStyles: function() {
            if (this.model.get('isHidden')) {
                return;
            }

            var clientRect = this.el.getBoundingClientRect();
            var topPosition = clientRect.height;

            this.$container.css({
                position: 'absolute',
                width: clientRect.width + 'px',
                top: topPosition + 'px',
                left: '0'
            });
        },

        renderAutocomplete: function(items) {
            this.$container.html($(tmpl[this.options.template](items)));
            this.setMaxHeight();
        },

        setMaxHeight: function() {
            var item = this.$container.find('.fn-autocomplete-item')[0];
            var visibleRows = parseInt(this.options.visibleRows);

            if (item && isNumeric(visibleRows) && visibleRows > 0) {
                var height = parseFloat(getComputedStyle(item).height);
                var maxHeight = height * visibleRows + 'px';

                this.$container.css('max-height', maxHeight);
            }
        },

        findActiveItemIndex: function(target) {
            var index;

            while(target && index == null) {
                index = target.dataset.index;
                target = target.closest('[data-index]');
            }

            return index;
        }
    });

});
